import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { NftMoleculeReatom } from "../../store/nft-store.reatom"

export const useNftTraitsReatom = () => {
  const { nftQueryParamsAtom } = useMolecule(NftMoleculeReatom)

  // Get query params from atom and use with TanStack Query
  const queryParams = nftQueryParamsAtom()
  const {
    data: {
      nft: { traits },
    },
  } = useSuspenseQuery(queryParams)

  return traits
}
